<template>
  <LayoutSearchFieldVertical>
    <div class="keyword-line">
      <form class="search-keyword-field" @submit.prevent="addWords">
        <input
          class="jps-input jps-keyword-input"
          type="text"
          v-model="value"
          :placeholder="placeholder"
          @keyup.prevent.esc="value = ''"
        />
        <UiButtonIcon
          tag="button"
          type="submit"
          icon="mdi/plus-circle"
          icon-size="size-5"
          styled="secondary"
        />
      </form>
      <UiButtonRound class="start-map-button" @click="startMap()">
        {{ lss('地図で検索', 'Search by map') }}
      </UiButtonRound>
    </div>
    <div v-if="field.samples" class="sample-query">
      <dl>
        <dt class="jps-flex-center">
          {{ ls({ ja: '例', en: 'Example ' }) }}
        </dt>
        <dd v-for="keyword in field.samples" :key="keyword.ja">
          <UiButtonText @click="addKeyword(keyword.ja)">
            {{ ls(keyword) }}
          </UiButtonText>
        </dd>
      </dl>
    </div>
  </LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { ls, lss } = useI18n()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { placeholder } = useSearchFieldBase(props)

const value: Ref<string> = ref('')

const addWords = () => {
  if (value.value) props.ss.setQuery(props.field.key, split(value.value))
  else props.ss.setQuery(props.field.key, [])
}

const addKeyword = (word: string) => {
  props.ss.addQuery(props.field.key, [word])
}

const startMap = () => {
  if (props.ss.state.image && props.ss.state.image.length > 0) {
    props.ss.state.from = 0
  }
  props.ss.state.geoDistance[props.field.key] = [
    { lat: 35.3622222, lon: 138.7313889, distance: '100km' },
  ]
  props.ss.state.sort = ['geo:' + props.field.key]
  props.ss.state.size = 500
  props.ss.execute()
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

  .keyword-line {
    display: flex;
    gap: 0.75rem;

    .start-map-button {
      background-color: $white;
      border: 1px solid $jps-gray-300;
      color: $black;

      &:hover {
        color: $black;
        background-color: $jps-gray-300;
        border-color: $jps-gray-300;
      }
    }
  }
</style>
